import { Validators } from '@angular/forms';

import {
    DynamicField,
    DynamicFieldType,
    DynamicFieldTypes,
    DynamicLabel,
    noZeroRequiredValidator,
    InputTypes,
    NumericInputTypes,
    SelectInputTypes,
} from '@mt-ng2/dynamic-form';

import { IExpandableObject } from '../expandable-object';
import { IClosedDate } from '../interfaces/closed-date';

export interface IClosedDateDynamicControlsParameters {
    formGroup?: string;
}

export class ClosedDateDynamicControls {

    formGroup: string;

    Form: IExpandableObject;
    View: IExpandableObject;

    constructor(private closeddate?: IClosedDate, additionalParameters?: IClosedDateDynamicControlsParameters) {
        this.formGroup = additionalParameters && additionalParameters.formGroup || 'ClosedDate';

        this.Form = {
            DateClosed: new DynamicField({
                formGroup: this.formGroup,
                label: 'Date Closed',
                name: 'DateClosed',
                options: null,
                type: new DynamicFieldType({
                    fieldType: DynamicFieldTypes.Input,
                    inputType: InputTypes.Datepicker,
                    scale: null,
                }),
                validation: [ Validators.required ],
                validators: { 'required': true },
                value: this.closeddate && this.closeddate.DateClosed || null,
            }),
            Name: new DynamicField({
                formGroup: this.formGroup,
                label: 'Name',
                name: 'Name',
                options: null,
                type: new DynamicFieldType({
                    fieldType: DynamicFieldTypes.Input,
                    inputType: null,
                    scale: null,
                }),
                validation: [ Validators.maxLength(50) ],
                validators: { 'maxlength': 50 },
                value: this.closeddate && this.closeddate.hasOwnProperty('Name') && this.closeddate.Name != null ? this.closeddate.Name.toString() : '',
            }),
        };

        this.View = {
            DateClosed: new DynamicLabel({
                label: 'Date Closed',
                value: this.closeddate && this.closeddate.DateClosed || null,
                type: new DynamicFieldType({
                    fieldType: DynamicFieldTypes.Input,
                    inputType: InputTypes.Datepicker,
                    scale: null,
                }),
            }),
            Name: new DynamicLabel({
                label: 'Name',
                value: this.closeddate && this.closeddate.hasOwnProperty('Name') && this.closeddate.Name != null ? this.closeddate.Name.toString() : '',
                type: new DynamicFieldType({
                    fieldType: DynamicFieldTypes.Input,
                    inputType: null,
                    scale: null,
                }),
            }),
        };

    }
}
